import React from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	TextField,
	MenuItem,
	Button,
} from "@mui/material";

const AssignAdjusterDialog = ({
	open,
	onClose,
	users,
	loadingUsers,
	onChange,
	onAssign,
}) => (
	<Dialog open={open} onClose={onClose}>
		<DialogTitle>Assign Adjuster to the Assignment</DialogTitle>
		<DialogContent>
			<TextField
				label="Adjusters"
				name="adjusters"
				fullWidth
				select
				required
				margin="normal"
				onChange={onChange}
				disabled={loadingUsers}
			>
				<MenuItem value="">-- Select --</MenuItem>
				{users.map((user) => (
					<MenuItem key={user.userName} value={user.userName}>
						{user.name}
					</MenuItem>
				))}
			</TextField>
		</DialogContent>
		<DialogActions>
			<Button onClick={onClose} color="primary">
				No
			</Button>
			<Button onClick={onAssign} color="primary">
				Yes
			</Button>
		</DialogActions>
	</Dialog>
);

export default AssignAdjusterDialog;
